import React, { FC } from 'react';
import { observer } from 'mobx-react';
import Credits from './credits';

const Admin: FC = observer(() => {
  return <Credits />;
});

export default Admin;
